// import Image from "next/image";
import HtmlParser from "@/components/HtmlParser";
import { Heading, Text } from "@/components/Typography";
import { WP_Integrated_Image } from "@/models/image";
import { WP_Wysiwyg } from "@/models/wordpress";
import breakpoints from "@/styles/utils/media.module.scss";

import s from "./BackgroundInfo.module.scss";

interface Props {
	title?: string;
	content: WP_Wysiwyg;
	illustration?: WP_Integrated_Image;
	tasteProfile?: string;
}

export function BackgroundInfo({
	content,
	title,
	illustration,
	tasteProfile,
}: Props) {
	tasteProfile = tasteProfile?.replace(/\s/g, "");

	return (
		<section className={s.section}>
			<Heading as="h2" sizeMobile="xl" sizeDesktop="xl" className={s.heading}>
				{title ? (
					<> {title} </>
				) : (
					<>
						Een stukje <br /> achtergrond
					</>
				)}
			</Heading>
			<div className={s.content}>
				<Text>
					<HtmlParser content={content} />
				</Text>
			</div>
			<div className={s.illustration}>
				{illustration ? (
					<img
						className={s.image_block__image}
						sizes={`(min-width:${breakpoints.lg}) 700px, calc(100vw - 48px)`}
						srcSet={[
							`${illustration.sizes["medium"]}  ${illustration.sizes["medium-width"]}w`,
							`${illustration.sizes["medium_large"]} ${illustration.sizes["medium_large-width"]}w`,
							`${illustration.sizes["large"]} ${illustration.sizes["large-width"]}w`,
							`${illustration.sizes["illustration_large"]} ${illustration.sizes["illustration_large-width"]}w`,
						].join(", ")}
						alt={!!illustration.alt ? illustration.alt : undefined}
						loading="lazy"
					/>
				) : null}

				{tasteProfile ? (
					<img
						className={s.image_block__image}
						sizes={`(min-width:${breakpoints.lg}) 700px, calc(100vw - 48px)`}
						src={`/taste-styles/${tasteProfile}.svg`}
						role="presentation"
						alt=""
						loading="lazy"
					/>
				) : null}
			</div>
		</section>
	);
}
